import { render } from "./SiteNavigation.vue?vue&type=template&id=106ba97e&scoped=true"
import script from "./SiteNavigation.vue?vue&type=script&lang=js"
export * from "./SiteNavigation.vue?vue&type=script&lang=js"

import "./SiteNavigation.vue?vue&type=style&index=0&id=106ba97e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106ba97e"]])

export default __exports__